export default () => {

  const scrollPos = () => (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
  let _lastScrollTop = 0;

  const scrollHandler = () => {
  
		if (scrollPos() > _lastScrollTop) {
			if ((scrollPos() >= $('.appbar__menu--fixed').height()) && scrollPos() > 420) {
        $('.appbar__menu--fixed').css({
          top: "-200px",
          transition: "all 1s ease 0.2s"
        });
        $('header').css({
          top: "-200px",
          transition: "all 1s ease 0.2s"
        });
      
			}
		} else {
      $('.appbar__menu--fixed').css({top: ""});
      $('header').css({top: ""});

		}

		_lastScrollTop = scrollPos();

  }
  
  window.addEventListener('scroll', scrollHandler);

}